module.exports = ol.Observable;